<template>
  <label :for="htmlFor" class="pb-label" :layout-size="size">
    <slot />
  </label>
</template>
<script>
export default {
  name: "PbLabel",
  props: {
    htmlFor: String,
    size: {
      type: String,
      default: () => "default",
    },
  },
};
</script>
<style lang="scss">
.pb-label {
  &[layout-size="sub"] {
    font-size: 1.2rem;
  }

  &[layout-size="main"] {
    font-size: 1.4rem;
  }

  &[layout-size="default"] {
    font-size: 1.4rem;
  }

  & + * {
    padding-top: 0.4rem;
  }
}
</style>
